import React from 'react';

import CmsMediaSelector from 'components/cms/settings/components/CmsMediaSelector';
import CmsColorSelector from 'components/cms/settings/components/CmsColorSelector';
import CmsBackgroundRepeatSelector from 'components/cms/settings/components/CmsBackgroundRepeatSelector';
import CmsBackgroundSizeSelector from 'components/cms/settings/components/CmsBackgroundSizeSelector';
import CmsBackgroundPositionSelector from 'components/cms/settings/components/CmsBackgroundPositionSelector';
import CmsBackgroundAttachmentSelector from 'components/cms/settings/components/CmsBackgroundAttachmentSelector';

import FormInput from 'components/forms/FormInput';
import FormCodeEditor from 'components/forms/FormCodeEditor';

class CmsStyleSettings extends React.Component {
  render() {
    const {
      intl: { messages },
      setParam,
      getParamValue,
    } = this.props;

    return (
      <div class="form-group-attached">
        <CmsMediaSelector type="background" label={messages.background_image} {...this.props} />
        <CmsBackgroundSizeSelector {...this.props} />
        <CmsBackgroundRepeatSelector {...this.props} />
        <CmsBackgroundPositionSelector {...this.props} />
        <CmsBackgroundAttachmentSelector {...this.props} />
        <CmsColorSelector type="background" label={messages.background_color} {...this.props} />
        <FormInput
          name="cssClasses"
          label={messages.css_classes}
          value={getParamValue('cssClasses')}
          onChange={setParam}
        />
        <FormCodeEditor
          name="style"
          label={messages.style}
          value={getParamValue('style')}
          onChange={setParam}
          language="css"
        />
        <FormCodeEditor
          name="appendHtml"
          label={messages.append_html}
          value={getParamValue('appendHtml')}
          onChange={setParam}
          language="html"
        />
      </div>
    );
  }
}

export default CmsStyleSettings;
